import { Accordion as Mui4Accordion, AccordionProps as Mui4AccordionProps } from '@material-ui/core'
import { default as Mui5Accordion, AccordionProps as Mui5AccordionProps } from '@mui/material/Accordion'
import { forwardRef } from 'react'
import { useComponentVersion } from '../../hooks/useComponentVersion'

export enum OsAccordionVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

// Omit 'component' | 'onChange' to avoid incompatible MUI4/MUI5 types
export type AccordionProps = Omit<Mui5AccordionProps, 'component' | 'onChange'> & {
  onChange?: Mui5AccordionProps['onChange'] | Mui4AccordionProps['onChange']
  size?: 'small' // MUI V5 Accordion does not have a way to add additional props
  type?: 'nested' | 'unNested'
}

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>((props, ref) => {
  const version = useComponentVersion('accordion')

  const { onChange, sx, size, type = 'unNested', ...rest } = props

  switch (version) {
    case OsAccordionVersion.V2:
      return (
        <Mui5Accordion
          // @ts-ignore
          sx={(theme) => ({
            ...sx,
            ...(size === 'small' && {
              boxShadow: type === 'nested' ? 'none !important' : '0px 2px 16px 0px rgba(17, 17, 28, 0.08)',
              '& .OSUI-AccordionSummary-root': {
                padding: '16px',
                height: '56px !important',
                minHeight: '56px !important',
                borderRadius: '8px',
              },
              [theme.breakpoints.down(393)]: {
                '& .OSUI-AccordionSummary-root': {
                  padding: '12px',
                  height: '44px !important',
                  minHeight: '44px !important',
                },
              },
            }),
          })}
          onChange={onChange as Mui5AccordionProps['onChange']}
          {...rest}
          ref={ref}
        />
      )
    default:
      return <Mui4Accordion onChange={onChange as Mui4AccordionProps['onChange']} {...rest} ref={ref} />
  }
})
